// extracted by mini-css-extract-plugin
module.exports = {"singleFilter":"SingleFilter_singleFilter__3WFd1"};